define('atn/pdfUtils',['lodash', 'pdfmake', './utils', 'atn/atn', 'vfs_fonts'],
    function(_, pdfmake, utils, atn) {
        'use strict';

        /**
         * Message to be shown when there isno chart to display
         * @type {String}
         */
        var noChartToDisplayMessage = (
            atn.config.messages.graphs.noChartToDisplay
        );

        return {
            downloadPdf: downloadPdf,
            extractChart: extractChart,
            convertToPrintObject: convertToPrintObject,
            getPrintObject: getPrintObject
        };

        /**
         * to extract chart property out of chartobject
         * @param  {Object} chartObject mapping of chart properties
         * @return {Object}             object required to draw chart on pdf
         */
        function extractChart(chartObject) {
            var chart = {};
            if (chartObject.totalValueGraphCount() === null) {
                //in case chart doesn't have data
                chart.text = chartObject.noDataMessage;
            } else if (!chartObject.chartOptions.hasChartToDisplay()) {
                //  in case chart has data but user has deletected all the legends
                chart.text = noChartToDisplayMessage;
            } else {
                chart.image = {
                    image: chartObject.chartOptions.highchartToJPEG(428, 280, 'jpeg'),
                    width: 428,
                    height: 280
                };
            }
            return chart;
        }

        /**
         * to create a pdf doc using pdfmake and download it
         * @param  {Object} config Object containing configuration
         * @param  {String} name   Name of file to be downloaded
         * @param  {Function} callback   Callback function when pdf-generation is finished
         * @return {Undefined}
         */
        function downloadPdf(config, name, callback) {
            if (utils.isInternetExplorer()) {
                pdfmake.createPdf(config).getBase64(function(b64Data) {
                    var blob = utils.b64toBlob(b64Data, 'application/pdf');
                    window.navigator.msSaveBlob(blob, name + '.pdf', 1024);
                    if (_.isFunction(callback)) {
                        callback();
                    }
                });
            } else if (utils.isSafari()) {
                var pdfSafari = pdfmake.createPdf(config);
                pdfSafari.download(name + '.pdf');
                if (_.isFunction(callback)) {
                    callback();
                }
            } else {
                var pdf = pdfmake.createPdf(config);
                pdf.getBuffer(function(data) {
                    atn.utils.downloadFile(
                        name + '.pdf', [data],
                        'application/pdf',
                        callback
                    );
                });
            }
        }

        /**
         * convert existing object to an object that can be used to generate 
         * pdfs using pdfmake
         * 
         * if obj.value has unicode character, obj.value will be removed and 
         * obj.image having properties image(datauri of image), 
         * width and height is added else the object remain as it is
         *
         * {value: 'abcef'}
         * // => {value: 'abcef'}
         *
         * {value: 'abe두f'}
         * // => {image: {image: 'data:image/png,base64,.....', width: 12, height: 20}}
         * 
         * @param  {Object} obj     the existing object
         * @param  {Object} options Options for creating images
         * @return {Object}         object that can be used to generate 
         *                          pdfs using pdfmake
         */
        function convertToPrintObject(obj, options) {
            if (obj.value) {
                var printObj = getPrintObject(obj.value, options);
                if (printObj.image) {
                    delete obj.value;
                    obj.image = printObj;
                }
            }

            return obj;
        }

        /**
         * create a object that can be used to generate pdfs using pdfmake
         * from the string supplied
         *
         * 'abcef'
         * // => {value: 'abcef'}
         *
         *
         * 'abe두f'
         * // => {image: {image: 'data:image/png,base64,.....', width: 12, height: 20}}
         * 
         * @param  {String} str     String to be converted into pdfable object
         * @param  {Object} options Options for creating images
         * @return {Object}         object that can be used to generate 
         *                          pdfs using pdfmake
         */
        function getPrintObject(str, options) {
            var obj;
            if (atn.utils.hasUnicode(str)) {
                var strImage = atn.utils.getStrImage(str, options);
                obj = {
                    image: strImage.src,
                    width: strImage.width,
                    height: strImage.height
                };
            } else {
                obj = {
                    value: str
                };
            }

            return obj;
        }
    });

